<template>
  <section class="entity-room-display-trip-advisor d-none d-lg-block mb-3">
    <div class="slider-tripadvisor border-alto p-5">
      <div class="row">
        <div class="col-12 d-xl-flex">
          <span class="font-bold text-22">{{ info.rating.bubbleRating.toFixed(1) }}</span>
          <img
            :src="`https://www.tripadvisor.com/img/cdsi/img2/ratings/traveler/${info.rating.bubbleRating.toFixed(1)}-MCID-5.svg`"
            alt=""
            class="tripadvisor-rating"
          />
        </div>
        <div class="col-12 ${not empty tripAdvisorReviews ? 'mb-4' : ''}">
          <span class="text-12">
            {{ translate('rdReviews', info.rating.reviewCount, info.rating.reviewCount) }}
          </span>
        </div>
      </div>

      <Slider
        v-if="info.reviews"
        class="pt-4"
        selector=".tripadvisor__reviews"
        :slides-to-show="1"
        :slides-to-scroll="1"
        :adaptive-height="true"
      >
        <div class="tripadvisor__reviews row">
          <div class="col-12" v-for="(review, index) in info.reviews" :key="index">
            <div class="row">
              <div class="col-12">
                <p class="text-12 color-gunmetal">
                  {{
                    review.description.length > 200
                      ? review.description.substring(0, 200) + '...'
                      : review.description
                  }}
                </p>
              </div>
              <div class="col-12">
                <span class="font-bold text-12 d-block color-gunmetal">{{
                  review.traveler.name
                }}</span>
                <span class="text-12 color-grey-cool" v-if="review.traveler.location">{{
                  review.traveler.location
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </Slider>
    </div>
  </section>
</template>

<script>
import TripAdvisor from '../../domain/TripAdvisor'
import Slider from '../Slider'

export default {
  name: 'TripAdvisor',
  components: { Slider },
  props: {
    info: {
      type: TripAdvisor
    }
  }
}
</script>

<style lang="scss">
.slider-tripadvisor {
  background: white;

  @media (min-width: 992px) {
    border-radius: 8px;
  }
  .slick-list {
    margin-bottom: 0;
  }

  .slick-arrow {
    &::after,
    &::before {
      color: color('gunmetal');
      font-size: 1.4rem;
    }

    &.slick-prev {
      left: -1.5rem;
    }

    &.slick-next {
      right: -2rem;
    }

    &:focus {
      background: none;
    }
  }
}
</style>
